@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;

  .chart-empty {
    display: none;
  }

  .widget-missing-license {
    display: none;
  }

  .widget-missing-msp-license {
    display: none;
  }

  &.is-loading {
    .chart-content {
      display: none;
    }
    .chart-legend {
      display: none;
    }
  }

  &.is-missing-license,
  &.is-error,
  &.is-empty {
    .chart-empty {
      display: flex;
    }
    .incidents-chart {
      display: none;
    }
  }

  &.is-error {
    .widget-missing-license {
      display: none;
    }
  }

  &.is-missing-license {
    .widget-missing-license {
      display: flex;
      flex-direction: column;
    }
    .incidents-list {
      display: none;
    }
  }

  &.is-missing-msp-license,
  &.is-error,
  &.is-empty {
    .chart-empty {
      display: flex;
    }
    .incidents-chart {
      display: none;
    }
  }

  &.is-error {
    .widget-missing-msp-license {
      display: none;
    }
  }

  &.is-missing-msp-license {
    .widget-missing-msp-license {
      display: flex;
      flex-direction: column;
    }
    .incidents-list {
      display: none;
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 3);
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-top: var(--spacer);

  .chart-legend {
    width: 100%;
    align-self: center;
    margin-right: auto;
  }

  .incidents-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .chart-content {
    display: flex;
    align-items: center;
    margin-bottom: var(--spacer);

    .incidents-chart {
      width: 160px;
      height: 160px;
    }

    .bb-chart-arcs-title {
      fill: var(--main-titles-inputs-600);
    }

    path {
      cursor: auto !important;
    }
  }

  &.incidents-breakdown-container {
    flex-direction: column;
  }

  .bb-tooltip-container {
    padding: 0;
  }

  .chart-tooltip {
    font-size: var(--tooltip-font-size);
    font-family: var(--font-family-secondary);
    color: var(--main-titles-inputs-600);
    background-color: var(--white-layout-303-level-2-elevation);
    box-shadow: 0px 0px 6px 0px var(--chart-050-hover);
    border-radius: calc(var(--spacer) * 0.5);
    padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 2);
    position: absolute;
    z-index: 2;
    transform: translate(-50%, -100%);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacer);
    min-width: 200px;

    span {
      font-family: var(--font-family-secondary);
    }

    .value {
      margin-left: auto;
    }
  }
}

.no-list-content {
  display: none;
}

@media screen and (max-width: 1600px) {
  .content {
    .chart-content {
      margin-right: 0;

      .incidents-chart {
        width: 130px;
        height: 130px;
      }
    }

    .incidents-list {
      .gz-data-item {
        &--title {
          margin-right: var(--spacer) !important;
        }

        &--value {
          color: var(--main-titles-inputs-600);
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .content {
    margin-top: calc(var(--spacer) * 2);

    .chart-content {
      transform: translate(0px, -3px);
      width: 140px;
      height: 140px;
      margin-bottom: 3px;

      .incidents-chart,
      .donut-chart-error {
        width: 140px;
        height: 140px;
      }
    }
    .chart-legend {
      padding: 0;
      transform: translate(0px, 4px);
    }
    .gz-data-item {
      font-size: var(--body-size-xsmall);
      align-items: center;
    }

    .gz-data-item--value {
      font-size: var(--body-size);
    }
  }
}
